import React, { useState, useEffect } from "react";
import axios from "axios";
import ButtonOptionGroup from "../../component/ButtonOptions/ButtonOption";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportBalanceSheet = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/neraca";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    // Fetch data from the API
    const fetchData = async (URL) => {
        setLoading(true);
        setError(null); // Clear previous errors
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch data on component mount or filter change
    useEffect(() => {
        if (filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?last_date=${filterLastDate}`).then((responseData) => {
                setData(responseData || []); // Ensure data is an array
            });
        }
    }, []);

    const handleFilter = () => {
        if (filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?last_date=${filterLastDate}`).then((responseData) => {
                setData(responseData || []); // Ensure data is an array
            });
        }
    };

    const options = [
        { value: 'excel', label: 'Excel' },
        { value: 'pdf', label: 'PDF' },
        { value: 'csv', label: 'CSV' }
    ];

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <div className='flex items-center justify-between'>
                <h1 className="text-lg font-bold mb-4">Laporan Posisi Keuangan</h1>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Ekspor"}
                        options={options}
                        onChange={async (value) => {
                            if (value == 'excel') {
                                const payload = {
                                    last_date: filterLastDate
                                };
                                const response = await axios.post(`${BASE_URL}${PATH_REPORT}/exportexcel`, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                    }
                                });

                                setMessage(response.data);
                            } else if (value == 'pdf') {

                            } else if (value == 'csv') {

                            }
                        }}
                    />
                </div>
            </div>

            {error ? (
                <p className="bg-red-400 text-white p-2 rounded">Error: {error}</p>
            ) : null}

            {message ? (
                <p className="bg-blue-100 text-black p-2 rounded">{message}
                    <a href="/activity-erpppsu/import-export/exports"> Lihat daftar ekspor</a>
                </p>
            ) : null}


            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Filter Button */}
                <div className="p-2 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {/* Display Data */}
            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                data.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="mb-6">
                        <h2 className="text-md font-semibold mb-2">{section.label}</h2>
                        {section.data.map((subSection, subSectionIndex) => {

                            const total = subSection.data?.reduce((acc, item) => acc + Number(item.current_balance), 0) || 0;

                            return (
                                <div key={subSectionIndex} className="mb-4">
                                    <h3 className="text-sm font-medium mb-2">{subSection.label}</h3>
                                    {subSection.data.length > 0 ? (
                                        <table className="min-w-full border-collapse border border-gray-300">
                                            <thead>
                                                <tr>
                                                    <th className="border border-gray-300 px-2 py-1 text-left">Code</th>
                                                    <th className="border border-gray-300 px-2 py-1 text-left">Name</th>
                                                    <th className="border border-gray-300 px-2 py-1 text-right">Current Balance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {subSection.data.map((item, itemIndex) => (
                                                    <tr key={itemIndex}>
                                                        <td className="border border-gray-300 px-2 py-1">{item.account_code}</td>
                                                        <td className="border border-gray-300 px-2 py-1">{item.account_name}</td>
                                                        <td className="border border-gray-300 px-2 py-1 text-right">{Number(item.current_balance).toLocaleString("id-ID")}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td className="border px-2 py-1 font-semibold" colSpan={2}>
                                                        Total
                                                    </td>
                                                    <td className="border px-2 py-1 text-right font-semibold">
                                                        {Number(total).toLocaleString("id-ID")}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    ) : (
                                        <p className="text-sm text-gray-500">No data available.</p>
                                    )}
                                </div>
                            );

                        })}
                    </div>
                ))
            )}
        </div>
    );
};

export default ReportBalanceSheet;
